import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const epicsBase = `${u}/epics`;
const storiesBase = `${u}/stories`;

export const getStories = (epicId) =>
  apiFetch(`${epicsBase}/${epicId}/stories`).then(r => r.ok ? r.json() : Promise.reject(r));

export const getStory = (epicId, storyId) =>
  apiFetch(`${epicsBase}/${epicId}/stories/${storyId}`).then(r => r.ok ? r.json() : Promise.reject(r));

export const createStory = (epicId, data) =>
  apiFetch(`${epicsBase}/${epicId}/stories`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const updateStory = (epicId, storyId, data) =>
  apiFetch(`${epicsBase}/${epicId}/stories/${storyId}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const deleteStory = (epicId, storyId) =>
  apiFetch(`${epicsBase}/${epicId}/stories/${storyId}`, { method: "DELETE" });

export const getStoryTasks = (storyId) =>
  apiFetch(`${storiesBase}/${storyId}/tasks`).then(r => r.ok ? r.json() : Promise.reject(r));
